import React, { useEffect } from 'react';
import clsx from 'clsx';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
import { useSelector, useDispatch } from 'react-redux';
import { Scrollbars } from 'react-custom-scrollbars';

import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';

import { curMenu } from 'modules/menu';

import Icon from 'components/atoms/Icon';
import AdminNav from 'components/organisms/Nav/AdminNav';
import HeaderContainer from 'components/organisms/Header/HeaderContainer';
import CurrentStatus from 'components/atoms/CurrentStatus';

const drawerWidth = 250;

const adminTemplateStyles = makeStyles((theme) => ({
  // 좌측 메뉴와 컨텐츠 영역을 묶어주는 영역 style
  mainSection: {
    position: 'absolute',
    display: 'flex',
    width: '100%',
    height: 'calc(100% - 50px)',
    overflowX: 'auto',
    '&.navPop': {
      height: '100%',
    },
  },
  secHorizScroll: {
    '& > div': {
      display: 'flex',
      position: 'static',
      zIndex: theme.zIndex.secHorizScroll,
      width: 'calc(100% - -20px)',
      height: 'calc(100% - -20px)',
    },
  },

  // 좌측 메뉴 관련 style
  drawer: {
    '& > div': {
      position: 'relative',
      boxSizing: 'border-box',
    },
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    backgroundColor: '#3a4652',
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9) + 1,
    },
  },

  // 페이지 경로 영역 관련 style
  breadcrumbs: { color: theme.palette.primary.breadcrumbs },
  currentLocation: { color: theme.palette.primary.breadcrumbsAccent },
  greaterThan: {
    margin: '4px 8px 0',
    color: theme.palette.primary.breadcrumbsGreaterThan,
  },

  // 컨텐츠 영역 관련 style
  contents: {
    flex: '1 0 auto',
    overflow: 'hidden',
    width: 'calc(100% - 73px)',
    backgroundColor: '#eef2f5',
    overflowX: 'hidden',
    transitionDuration: '0.3s',
    '&.navOpen': {
      left: drawerWidth,
      width: 'calc(100% - 250px)',
    },
    '&.navPop': {
      left: 0,
      top: 0,
    },
  },
  content: {
    minWidth: 340,
    minHeight: 780,
    padding: '0 ' + theme.spacing(2) + 'px',
    paddingBottom: 50,
  },
  footer: {
    width: '100%',
    margin: '20px auto',
    textAlign: 'center',
    fontSize: 12,
  },
}));

let navOpenVal = true;
/**
 * 현제 url 에 맞는 url path 리턴
 * @param {Map} menu
 * @param {string} curUrl
 */
const makeMenuMap = (menu, curUrl) => {
  let result = null;
  for (let curMenu of menu.values()) {
    if (result !== null) {
      break;
    }
    if (curMenu.menuUrl === curUrl) {
      result = curMenu.menuPathNm;
      break;
    } else if (typeof curMenu.subMenu !== 'undefined') {
      result = makeMenuMap(curMenu.subMenu, curUrl);
    }
  }
  return result;
};

const MainTemplate = React.memo(({ location, children, loading = false }) => {
  const dispatch = useDispatch();
  const classes = adminTemplateStyles();
  const [navOpen, setNavOpen] = React.useState(navOpenVal);
  const { menu } = useSelector(({ menu }) => ({
    menu,
  }));
  const [pathArray, setPathArray] = React.useState([]);
  const [path, setParh] = React.useState(location.pathname);
  const { isPop, isFrame, isEmbed } = queryString.parse(location.search);

  useEffect(() => {
    let curMenuPath = '';
    if (!!menu.list) {
      curMenuPath = makeMenuMap(menu.list, location.pathname);
      if (!menu['curMenu']) {
        dispatch(curMenu(curMenuPath));
      } else if (!!curMenuPath) {
        let newArray = [];
        for (let value of curMenuPath.split('>')) {
          newArray.push(value.trim());
        }
        setPathArray(newArray);
        if (location.pathname !== path) {
          dispatch(curMenu(curMenuPath));
        }
      }
    }
    if (location.pathname !== path) {
      setParh(location.pathname);
    }
  }, [menu, location.pathname, dispatch, path]);

  function handleDrawerToggle() {
    navOpenVal = !navOpen;
    setNavOpen(navOpenVal);
  }

  return (
    <>
      {typeof isPop === 'undefined' &&
      typeof isFrame === 'undefined' &&
      typeof isEmbed === 'undefined' ? (
        <HeaderContainer />
      ) : (
        ''
      )}
      <div
        className={
          typeof isPop === 'undefined' &&
          typeof isFrame === 'undefined' &&
          typeof isEmbed === 'undefined'
            ? clsx(classes.mainSection, { navOpen })
            : clsx(classes.mainSection, 'navPop')
        }
      >
        <Scrollbars className={classes.secHorizScroll}>
          {typeof isPop === 'undefined' &&
          typeof isFrame === 'undefined' &&
          typeof isEmbed === 'undefined' ? (
            <Drawer
              variant="permanent"
              className={clsx(classes.drawer, {
                [classes.drawerOpen]: navOpen,
                [classes.drawerClose]: !navOpen,
              })}
              classes={{
                paper: clsx({
                  [classes.drawerOpen]: navOpen,
                  [classes.drawerClose]: !navOpen,
                }),
              }}
              open={navOpen}
            >
              <AdminNav
                navOpen={navOpen}
                handleDrawerToggle={handleDrawerToggle}
              />
            </Drawer>
          ) : (
            ''
          )}

          <div
            className={
              typeof isPop === 'undefined' &&
              typeof isFrame === 'undefined' &&
              typeof isEmbed === 'undefined'
                ? clsx(classes.contents, { navOpen })
                : clsx(classes.contents, 'navPop')
            }
          >
            <Scrollbars id={'secVerScroll'} autoHide>
              <div id="menuCrum" className="globals-Breadcrumbs">
                {pathArray.map((menuPath, index, array) => {
                  let result = null;
                  menuPath = menuPath.trim();
                  if (index + 1 === array.length) {
                    result = (
                      <div key={index} className={classes.currentLocation}>
                        {menuPath}
                      </div>
                    );
                  } else {
                    result = (
                      <div key={index} className={classes.breadcrumbs}>
                        {menuPath}
                        <Icon
                          icon="faAngleRight"
                          className={classes.greaterThan}
                        />
                      </div>
                    );
                  }
                  return result;
                })}
              </div>
              <div className={classes.content}>{children}</div>
              {typeof isPop === 'undefined' && (
                <div className={classes.footer}>
                  (주)인라이플 | 사업자번호:113-86-60934 | 사업자: 한경훈 | 주소: 서울특별시 구로구 구로동 디지털로 272
                  한신아이티타워
                  <br />
                  501호~504호 TEL .070-4672-2303 | FAX .02-865-6845 | E-mail :
                  mobon@enliple.com
                  <br />
                  Copyright(c) 2012 모비온 All rights reserved.
                </div>
              )}
            </Scrollbars>
          </div>
        </Scrollbars>
      </div>
      {loading && (
        <div
          style={{
            zIndex: 100000,
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgb(255 255 255 / 0.6)',
          }}
        >
          <CurrentStatus type="loading" />
        </div>
      )}
    </>
  );
});

export default withRouter(MainTemplate);
